import { useState } from "react";
import { Minus, Plus, Users } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const ROWS = [
  ["adults", "Adultes", "12 ans et plus", 1],
  ["children", "Enfants", "De 2 à 11 ans", 0],
  ["infants", "Bébés", "Moins de 2 ans", 0],
];

export const partyLabel = (p) => {
  const a = Number(p.adults ?? p.guests ?? 1), c = Number(p.children || 0), i = Number(p.infants || 0);
  const parts = [`${a} adulte${a > 1 ? "s" : ""}`];
  if (c) parts.push(`${c} enfant${c > 1 ? "s" : ""}`);
  if (i) parts.push(`${i} bébé${i > 1 ? "s" : ""}`);
  return parts.join(", ");
};

function Row({ k, label, hint, min, value, onChange, testid }) {
  const n = Number(value || 0);
  const btn = "w-9 h-9 rounded-full border border-[#EFE6DB] grid place-items-center text-[#123B4A] disabled:opacity-30";
  return (
    <div className="flex items-center justify-between gap-3 py-2.5">
      <div><p className="font-semibold text-sm text-[#123B4A]">{label}</p><p className="text-xs text-[#71828A]">{hint}</p></div>
      <div className="flex items-center gap-2">
        <button type="button" data-testid={`${testid}-${k}-minus`} disabled={n <= min} onClick={() => onChange(Math.max(min, n - 1))} className={btn}><Minus className="w-4 h-4" /></button>
        <input data-testid={`${testid}-${k}`} type="number" inputMode="numeric" min={min} value={value} onChange={(e) => onChange(e.target.value === "" ? "" : Math.max(min, parseInt(e.target.value, 10) || 0))} onBlur={() => { if (value === "") onChange(min); }} className="w-12 text-center border border-[#EFE6DB] rounded-lg py-1.5 text-sm" />
        <button type="button" data-testid={`${testid}-${k}-plus`} onClick={() => onChange(n + 1)} className={btn}><Plus className="w-4 h-4" /></button>
      </div>
    </div>
  );
}

export default function GuestPicker({ value, onChange, capacity, testid = "guests", className = "" }) {
  const [open, setOpen] = useState(false);
  const v = { adults: 1, children: 0, infants: 0, ...value };
  const total = Number(v.adults || 0) + Number(v.children || 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`w-full flex items-center gap-2 bg-white border border-[#EFE6DB] rounded-xl px-3 py-3 text-sm text-left text-[#17252B] ${className}`}>
          <Users className="w-4 h-4 shrink-0 text-[#38B5D8]" /><span data-testid={`${testid}-label`} className="truncate">{partyLabel(v)}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[300px] bg-white z-[120] divide-y divide-[#EFE6DB]">
        {ROWS.map(([k, label, hint, min]) => <Row key={k} k={k} label={label} hint={hint} min={min} value={v[k]} testid={testid} onChange={(n) => onChange({ ...v, [k]: n })} />)}
        <div className="pt-2.5">
          {capacity ? <p data-testid={`${testid}-capacity`} className={`text-xs ${total > capacity ? "text-[#B45309] font-semibold" : "text-[#71828A]"}`}>Capacité indiquée : {capacity} personne(s). {total > capacity ? "Vous pouvez quand même envoyer votre demande : le propriétaire décidera." : "Les bébés ne sont pas comptés."}</p>
            : <p className="text-xs text-[#71828A]">Les bébés ne sont pas comptés dans la capacité.</p>}
          <button type="button" data-testid={`${testid}-done`} onClick={() => setOpen(false)} className="w-full mt-2 text-sm font-bold text-white bg-[#123B4A] rounded-full py-2">Valider</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
